import {MembersPageState} from '../types/state'

export const getTickets = (state: MembersPageState) => state.tickets

export const getEventTickets = (state: MembersPageState, eventId: string) => state.tickets[eventId]
